export default function CarrierDriverManagement() {

  return (
      <p>مدیریت رانندگان</p>
  );
};